import { createAction } from "../fns/createAction";
import { fns, libTypes } from "@holta/lib";
import toast, { Toaster } from 'react-hot-toast';

export const setProductionOrders = createAction("SET_PRODUCTION_ORDERS", (newState, orders: libTypes.Order[]) => {
    newState.productionOrders = fns.orders.filterActiveOrders(orders);
});
